import React, { Fragment, useEffect, useMemo, useState } from "react";

import ReactTable from "components/ReactTable/ReactTable.js";
import Button from "components/CustomButtons/Button.js";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { Add } from "@material-ui/icons";

import { wsGetAll, wsFindBy } from "services/WService.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
}));

const categoryTableColumns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "Código", accessor: "code", width: 110 },
  { Header: "Descripción", accessor: "description" },
  { Header: "Agregar", accessor: "actions", excelEnabled: false }
];

export default function Category(props) {
  const classes = useStyles();
  const { providers } = props;

  const statePromo =
    props.promo.state == "N" || props.promo.state == "G" ? false : true;

  const [categories, setCategories] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [providerId, setProviderId] = useState(0);

  async function listCategory(provider_id = 0) {
    let response =
      provider_id == 0
        ? await wsGetAll('prom/promotion/group-stock/category')
        : await wsFindBy(
            'prom/promotion/group-stock/category',
            'base_business_partner_id',
            provider_id,
          );
    if (response.success) {
      setCategories(response.data.categories);
      setWarehouses(response.data.warehouses);
    }
  }

  useEffect(() => {
    listCategory(providerId);
  }, [providerId, props.promo]);

  useEffect(() => {
    setProviderId(props.promo.base_business_partner_id);
  }, [props.promo]);

  const columns = useMemo(() => {
    if(warehouses.length === 0) return categoryTableColumns;

    let columns = [];
    let index = categoryTableColumns.findIndex((item) => item.accessor === 'description');
    for (let i = 0; i <= index; i++) {
      columns.push(categoryTableColumns[i]);
    }
    for(let warehouse of warehouses){
      columns.push({
        Header: warehouse.WhsName.replace('Almacén', ''),
        accessor: `WHS-${warehouse.id}`,
        width: 85,
      });
    }
    for (let i = index + 1; i < categoryTableColumns.length; i++) {
      columns.push(categoryTableColumns[i]);
    }
    return columns;
  }, [warehouses]);

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={4}>
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Proveedor</InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              value={providerId || 0}
              onChange={(e) => {
                setProviderId(e.target.value);
              }}
            >
              <MenuItem value={0}>Ninguno</MenuItem>
              {providers.map((provider, i) => {
                return (
                  <MenuItem value={provider.id} key={i}>
                    {provider.CardName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </GridItem>
      </GridContainer>
      <ReactTable
        exportExcel={false}
        heightRow={50}
        columns={columns}
        data={categories.map((category, i) => {
          let dataStocks = {};
          for (let stock of category.stocks) {
            dataStocks[`WHS-${stock.logi_warehouse_id}`] =
              parseFloat(stock.OnHand) - parseFloat(stock.IsCommited);
          }
          return {
            num: i + 1,
            code: category.code,
            description: category.description,
            ...dataStocks,
            actions: (
              <div className="actions-right">
                <Button
                  justIcon
                  color="success"
                  className="like"
                  size="sm"
                  round
                  onClick={() => {
                    props.addProduct(category);
                    /* console.log("categoría", category) */
                  }}
                  disabled={statePromo}
                >
                  <Add />
                </Button>
              </div>
            )
          };
        })}
      />
    </Fragment>
  );
}
